<template lang="">
    <div>
        It Works!
    </div>
</template>
<script>
export default {
    name: 'ModalContentTest'
}
</script>